import { Observable } from "rxjs";
import { ChangePasswordRequest, LoginRequest } from "../models/login.model";
import { LoginResponse } from "../models/login.model";

export abstract class AuthRepository {
    // abstract login(email: string, password: string): Observable<any>;
    abstract login(request: LoginRequest): Observable<LoginResponse>;

    abstract changePassword(reguest: ChangePasswordRequest): Observable<any>;
}
